import React from "react";
import Skeleton from "react-loading-skeleton";

export default function RowSkeleton({ tableData }) {
  return [1, 2, 3, 4, 5].map((item) => {
    return (
      <tr>
        {tableData.map((item) => {
          return (
            <td style={{ padding: "15px 20px" }}>
              <Skeleton height={55} width={"100%"} />
            </td>
          );
        })}
      </tr>
    );
  });
}
